import { Pagination, Table, Tag } from 'antd';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import IconBack from '../../assets/Images/icons/icon-back';
import RopaService from '../../services/Ropa.service';

export default function HistoryDetail() {
    const navigate = useNavigate();
    const { t, i18n } = useTranslation();
    let { activityHistoryId } = useParams();
    const [historyInfo, setHistoryInfo] = useState([]);

    const [loading, setLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState({
        page: 1,
        pageSize: 10,
        total: 0,
    });

    useEffect(() => {
        getHistoryDetail();
    }, [activityHistoryId]);

    const getHistoryDetail = async (pageValue) => {
        try {
            const { data } = await RopaService.getHistoryDetail({
                activityHistoryId: activityHistoryId,
                p: pageValue.page ? pageValue.page : 1,
                ps: pageValue.pageSize ? pageValue.pageSize : 10,
            });
            setLoading(false);
            setHistoryInfo(data?.resultData || []);
            setCurrentPage({
                page: data?.resultData.page,
                pageSize: data?.resultData.pageSize,
                total: data?.resultData.total,
            });
        } catch (err) {
            setLoading(false);
            console.log(err);
        }
    };

    useEffect(() => {
        if (loading) {
            getHistoryDetail(currentPage);
        }
    }, [currentPage.page, currentPage.pageSize]);

    const _getTagStatus = (e) => {
        switch (e.statusEn) {
            case 'Draft':
                return (
                    <Tag
                        className="rounded-xl -my-1 text-center px-4"
                        style={{ color: '#65707A', borderColor: '#65707A' }}
                    >
                        {i18n.language === 'en' ? e.statusEn : e.statusTh}
                    </Tag>
                );
            case 'Waiting for Review':
                return (
                    <Tag
                        className="rounded-xl -my-1 text-center px-4 text-white"
                        style={{ color: '#F9C153', borderColor: '#F9C153' }}
                    >
                        {i18n.language === 'en' ? e.statusEn : e.statusTh}
                    </Tag>
                );
            case 'Reviewed':
                return (
                    <Tag
                        className="rounded-xl -my-1 text-center px-4 text-white"
                        style={{ color: '#4ACE8F', borderColor: '#4ACE8F' }}
                    >
                        {i18n.language === 'en' ? e.statusEn : e.statusTh}
                    </Tag>
                );
            case 'Revise':
                return (
                    <Tag
                        className="rounded-xl -my-1 text-center px-4 text-white"
                        style={{ color: '#F0536F', borderColor: '#F0536F' }}
                    >
                        {i18n.language === 'en' ? e.statusEn : e.statusTh}
                    </Tag>
                );
            case 'Publish':
                return (
                    <Tag
                        className="rounded-xl -my-1 text-center px-4 text-white"
                        style={{ color: '#FFFFFF', borderColor: '#7B67FB' }}
                    >
                        {i18n.language === 'en' ? e.statusEn : e.statusTh}
                    </Tag>
                );
            default:
                return '-';
        }
    };

    const columns = [
        {
            title: <div>{t('Title')}</div>,
            dataIndex: 'title',
            key: 'title',
            width: '34%',
            render: (_, record) =>
                i18n.language === 'en' ? record.titleEn : record.titleTh,
        },
        {
            title: <div>{t('Data from this version')}</div>,
            dataIndex: 'newValue',
            key: 'newValue',
            render: (_, { newValue }) => (
                <>
                    {newValue.length > 0 ? (
                        newValue.map((item, index) => {
                            if (
                                typeof item === 'string' &&
                                item.includes('\n')
                            ) {
                                return item
                                    .split('\n')
                                    .map((part, subIndex) => (
                                        <div
                                            key={`${index}-${subIndex}`}
                                            className="text-gray-600"
                                        >
                                            {part.trim()}
                                        </div>
                                    ));
                            }
                            return (
                                <div key={index} className="text-gray-600">
                                    {item}
                                </div>
                            );
                        })
                    ) : (
                        <div className="text-gray-600">-</div>
                    )}
                </>
            ),
        },
    ];

    return (
        <div>
            <div className="title flex">
                <button
                    className="cursor-pointer mr-3"
                    onClick={() => {
                        // navigate(`/risk-assessment/${riskId}/view`);
                        navigate(-1);
                    }}
                >
                    <IconBack />
                </button>
                {t('History')}
            </div>
            <div className="sub-title">
                <span className="text-sm text-gray-400">
                    {t('Data Inventory')} /
                </span>
                <span className="text-sm text-gray-400">
                    {t('RoPA List')} /
                </span>
                <span className="text-sm text-gray-400">
                    {t('RoPA Detail')} /
                </span>
                <span> {t('History')} </span>
            </div>
            <div className="bg-white rounded-xl p-4 my-4">
                <div className="grid grid-cols-2 p-4">
                    <div className="col-span-1">
                        <div className="grid grid-cols-6 pb-2">
                            <div className="col-span-1 font-semibold">
                                {t('Name')} :
                            </div>
                            <div className="col-span-5">
                                {historyInfo?.activityNameTh || '-'}
                            </div>
                        </div>
                        <div className="grid grid-cols-6 pb-2">
                            <div className="col-span-1 font-semibold">
                                {t('LogDate')} :
                            </div>
                            <div className="col-span-5">
                                {historyInfo?.logDate
                                    ? moment(historyInfo.logDate).format(
                                          'DD/MM/YYYY HH:mm'
                                      )
                                    : '-'}
                            </div>
                        </div>
                        <div className="grid grid-cols-6 pb-2">
                            <div className="col-span-1 font-semibold">
                                {t('Update By')} :
                            </div>
                            <div className="col-span-5">
                                {historyInfo?.logBy || '-'}
                            </div>
                        </div>
                        <div className="grid grid-cols-6 pb-2">
                            <div className="col-span-1 font-semibold">
                                {t('Version')} :
                            </div>
                            <div className="col-span-5">
                                {historyInfo?.version || '-'}
                            </div>
                        </div>
                    </div>
                    <div className="col-span-1">
                        <div className="grid grid-cols-8 pb-2">
                            <div className="col-span-2 font-semibold">
                                {t('Status')} :
                            </div>
                            <div className="col-span-6">
                                {_getTagStatus(historyInfo)}
                            </div>
                        </div>
                        <div className="grid grid-cols-8 pb-2">
                            <div className="col-span-2 font-semibold">
                                {t('Reason')} :
                            </div>
                            <div className="col-span-6">
                                {historyInfo.statusEn === 'Revise'
                                    ? historyInfo.reason
                                    : '-'}
                            </div>
                        </div>
                        <div className="grid grid-cols-8 pb-2">
                            <div className="col-span-2 font-semibold">
                                {t('Comment')} :
                            </div>
                            <div className="col-span-6">
                                {historyInfo.comment}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="bg-white rounded-xl p-4">
                <Table
                    bordered
                    className="inbox_table"
                    dataSource={historyInfo?.activityHistoryDifResponse}
                    columns={columns}
                    pagination={false}
                />
            </div>
            <div className="w-full text-right mt-4">
                <Pagination
                    current={currentPage?.page || 1}
                    pageSizeOptions={[10, 25, 50, 100]}
                    defaultPageSize={currentPage?.pageSize}
                    total={currentPage?.total || 1}
                    onChange={(page, pageSize) => {
                        const pageValue = {
                            ...currentPage,
                            page: page,
                            pageSize: pageSize,
                        };
                        setLoading(true);
                        setCurrentPage(pageValue);
                    }}
                    showSizeChanger
                />
            </div>
        </div>
    );
}
